import type { TimeSelectOption } from './types';

/**
 * 시간 선택 옵션 배열을 생성합니다.
 * @description
 * - 원하는 길이만큼 숫자 기반의 시간 옵션을 생성합니다.
 * @param step - 간격 (기본 1). 예: length=60, step=15 → 0, 15, 30, 45
 * @example
 * // 시 옵션 0~23 생성
 * const hourOptions = buildTimeOptions(24, '시');
 * // 분 옵션 15분 단위
 * const minuteOptions = buildTimeOptions(60, '분', 15);
 */
export const buildTimeOptions = (
  length: number,
  step: number,
  suffix?: string,
): TimeSelectOption[] => {
  const options: TimeSelectOption[] = [];

  for (let index = 0; index < length; index += step) {
    options.push({
      value: index,
      text: `${String(index).padStart(2, '0')}${suffix || ''}`,
    });
  }

  return options;
};

/**
 * 주어진 값을 interval 옵션 중 가장 가까운 값으로 보정합니다.
 * (기존 value가 interval에 없을 때 Select에 표시할 값 결정용)
 */
export const snapToInterval = (value: number, interval: number): number => {
  if (interval <= 0) return value;
  const remainder = value % interval;
  const half = interval / 2;
  return remainder < half ? value - remainder : value + (interval - remainder);
};
